<template>
  <div class="mt-2">
    <v-card>
      <v-toolbar
        dense
        color="white"
        class="elevation-0"
      >
        <v-toolbar-title>
          <v-icon>mdi-file-document</v-icon>
          היסטוריית הזמנות
        </v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <v-progress-linear
          indeterminate
          height="2"
          v-if="fetching"
        ></v-progress-linear>
        <template v-else-if="orders.length">
          <v-data-table
            :headers="headers"
            :items="orders"
            must-sort
            :options.sync="options"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-start"><router-link :to="`/orders/${item._id}`">{{ item._id }}</router-link></td>
                <td class="text-start">{{ heDate(item.startDate, true) }}</td>
                <td class="text-start">{{ heDate(item.endDate, true) }}</td>
              </tr>
            </template>
          </v-data-table>
        </template>
        <v-alert
          :value="true"
          color="white"
          class="ma-0 grey--text"
          v-else
        >
          ללא הזמנות
        </v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { format, isAfter } from "date-fns";
import Mixins from '@/mixins/mixins';
// import shouldShow from "@/utils/shouldShow";

export default {
  data() {
    return {
      fetching: false,
      headers: [
        { text: "הזמנה", align: "right", value: "order" },
        { text: "תאריך התחלה", align: "right", value: "startDate" },
        { text: "תאריך סיום", align: "right", value: "endDate" }
      ],
      options: {
        sortDesc: [true],
        sortBy: ["startDate"]
      }
    };
  },
  methods: {
    format,
    fetchByTraveler() {
      this.fetching = true;
      let query = {
        traveler: this.customerId
      };
      this.$store
        .dispatch("API_GET", {
          url: "/orders",
          entityType: "orders",
          schema: "orderListSchema",
          params: { q: JSON.stringify(query), limit: 0 }
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    fetchByPayer() {
      this.fetching = true;
      let query = {
        payer: this.customerId
      };
      this.$store
        .dispatch("API_GET", {
          url: "/orders",
          entityType: "orders",
          schema: "orderListSchema",
          params: { q: JSON.stringify(query), limit: 0 }
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
  },
  computed: {
    orders() {
      return Object.values(this.$store.state.entities.orders)
        .filter(item => {
          return item.traveler === this.customerId || item.payer === this.customerId;
        })
        .sort((a, b) => {
          return isAfter(a.created, b.created) ? -1 : 1;
        });
    }
  },
  props: ["customerId"],
  watch: {},
  mounted() {
    this.fetchByTraveler();
    this.fetchByPayer();
  },
  components: {},
  mixins: [Mixins]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>